module.exports = __webpack_public_path__ + "img/yunnan.ea08c06b.jpg";